export const Defaults = Object.freeze({
    DATE_FORMAT: 'YYYY-MM-DD',
    CATEGORY_ID: 1,
});
